// extracted by mini-css-extract-plugin
module.exports = {"outer":"image-background-module--outer--yfCC9","inner":"image-background-module--inner--2rkKW"};